// extracted by mini-css-extract-plugin
export default {"badge":"badge__badge__wQD8t","dark":"badge__dark__kEEM7","badge-live":"badge__badge-live__Le6Aa","badge-draft":"badge__badge-draft__H9Tcl"};